// extracted by mini-css-extract-plugin
export default {"applyColorButton":"OZ9Moj5IlR","applyColorButton_disabled":"lvnh_mlr5t"};